import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const Inicio = () => {
    let navigate = useNavigate();
    const {code} = useParams();

    const irAfiniquito = () => {
        console.log("NAVEGANDO A FINIQUITO "+code);
        navigate("../finiquito/"+code);
    }

    return (
        <div>
            <div className="row">
                <div className="col">
                    <button className="btn btn-success">RENOVAR</button>
                </div>
                <div className="col">
                    <button className="btn btn-warning">RECOMENDAR</button>
                </div>
                <div className="col">
                    <button className="btn btn-danger" onClick={irAfiniquito}>FINIQUITAR</button>
                </div>
            </div>
        </div>
    );
};

export default Inicio;